// =============================================================================
// ============= Car Overview Card Static Data ===============
// =============================================================================

export interface MediaTab {
  label: string;
  icon: string;
  id?: string;
  href?: string;
}

export const MEDIA_TABS: MediaTab[] = [
  {
    label: "Image",
    icon: "pdp-icons/pdp-image-icon.svg",
    href: "images",
  },
  {
    label: "Colours",
    icon: "pdp-icons/color-icon.svg",
    id: "colours",
  },
  {
    label: "Videos",
    icon: "pdp-icons/video-icon.svg",
    id: "videos-section",
  },
];

// =============================================================================
// ============= Slider Configuration ===============
// =============================================================================

export const SLIDER_CONFIG = {
  desktop: {
    itemsToShow: 1,
    showArrows: true,
    showDots: true,
    autoSlide: true,
    autoSlideInterval: 5000,
    infinite: true,
  },
  mobile: {
    itemsToShow: 1,
    showArrows: false, // Hidden on mobile per design
    showDots: true,
    autoSlide: true,
    autoSlideInterval: 5000,
    infinite: true,
  },
};

// Lastest Update Data

export interface UpdateItem {
  id: number;
  date: string;
  isLatest: boolean;
  description: string;
}

export interface LatestUpdatesData {
  title: string;
  updates: UpdateItem[];
}

export const latestUpdatesData: LatestUpdatesData = {
  title: "BMW M8 Coupe Competition Latest Updates",
  updates: [
    {
      id: 1,
      date: "27 Feb 2026",
      isLatest: true,
      description: "The top-spec Mahindra XEV 9S now gets a custom drive mode allowing customers to tweak powertrain response, suspension setting, and steering wheel."
    },
    {
      id: 2,
      date: "3 Dec 2025",
      isLatest: false,
      description: "Bookings for the Mahindra XEV 9S electric SUV will open in January 2026."
    },
    {
      id: 3,
      date: "27 Nov 2025",
      isLatest: false,
      description: "The Mahindra XUV 9S seven-seater electric SUV has been launched at Rs. 19.95 lakh for the 59kWh version. The 79kWh variants will start at Rs. 21.95 lakh while a new 70kWh version starts at Rs. 24.45 lakh (ex-showroom prices)."
    },
    {
      id: 4,
      date: "15 Oct 2025",
      isLatest: false,
      description: "Additional performance updates: The M8 Coupe Competition receives a new adaptive M Suspension Pro system for better cornering stability."
    },
    {
      id: 5,
      date: "05 Aug 2025",
      isLatest: false,
      description: "New interior upholstery options including Alcantara and Merino leather combinations are now available for order in the premium segment."
    }
  ]
};

export const carLaunchData = {
  title: "BMW M3 GTR",
  price: "₹ 14.06 — 16.38 Lakh*",
  tagline: "LATEST BMW CAR LAUNCH · MAY 2026 ✨",
  imageUrl: "https://assets.tractorjunction.com/car-junction/images/mahindra-xuv700-front-view-118-2.webp", // Replace with your actual CDN path
  buttonText: "View Details"
};


// Varient table data

export const variantTableData = {
  title: "BMW M8 Coupe Competition  Variants",
  subtitle: "Lorem ipsum dolor sit amet, consectetur elit, elit, elit, adipiscing elit, sed do eiusmod tempor incididunt ",

  fuelTypes: [
    { label: "All", value: "All" },
    { label: "Diesel", value: "Diesel" },
    { label: "Petrol", value: "Petrol" },
    { label: "Cng", value: "Cng" },
    { label: "Electric", value: "Electric" },
  ],

  transmissionTypes: [
    { label: "All", value: "All" },
    { label: "Automatic", value: "Automatic" },
    { label: "Manual", value: "Manual" },
  ],

  variants: [
    { id: "1", name: "M8 Coupe Edition", engine: "1498 cc", transmission: "Manual", fuel: "Petrol", price: "₹11.49 Lakh", image: "https://picsum.photos/id/1015/400/240", mileage: "16 KM/L" },
    { id: "2", name: "M8 Gran Coupe", engine: "1498 cc", transmission: "Manual", fuel: "Petrol", price: "₹11.49 Lakh", image: "https://picsum.photos/id/1016/400/240", mileage: "16 KM/L" },
    { id: "3", name: "M8 Convertible", engine: "1498 cc", transmission: "Manual", fuel: "Petrol", price: "₹11.49 Lakh", image: "https://picsum.photos/id/201/400/240", mileage: "16 KM/L" },
    { id: "4", name: "M8 Competition", engine: "2998 cc", transmission: "Automatic", fuel: "Petrol", price: "₹1.45 Crore", image: "https://picsum.photos/id/237/400/240", mileage: "12 KM/L" },
    { id: "5", name: "M8 CS", engine: "2998 cc", transmission: "Automatic", fuel: "Petrol", price: "₹1.65 Crore", image: "https://picsum.photos/id/238/400/240", mileage: "11 KM/L" },
    { id: "6", name: "M8 xDrive", engine: "4395 cc", transmission: "Automatic", fuel: "Petrol", price: "₹2.10 Crore", image: "https://picsum.photos/id/239/400/240", mileage: "9 KM/L" },
    { id: "7", name: "M8 Electric", engine: "Electric", transmission: "Automatic", fuel: "Electric", price: "₹1.85 Crore", image: "https://picsum.photos/id/180/400/240", mileage: "450 KM" },
    { id: "8", name: "M8 Gran Coupe Luxury", engine: "2998 cc", transmission: "Automatic", fuel: "Petrol", price: "₹1.55 Crore", image: "https://picsum.photos/id/181/400/240", mileage: "13 KM/L" },
    { id: "9", name: "M8 Convertible Pro", engine: "2998 cc", transmission: "Automatic", fuel: "Petrol", price: "₹1.75 Crore", image: "https://picsum.photos/id/182/400/240", mileage: "12 KM/L" },
    { id: "10", name: "M8 CS Edition", engine: "4395 cc", transmission: "Automatic", fuel: "Petrol", price: "₹2.25 Crore", image: "https://picsum.photos/id/183/400/240", mileage: "10 KM/L" },
    { id: "11", name: "M8 Diesel", engine: "2993 cc", transmission: "Automatic", fuel: "Diesel", price: "₹1.35 Crore", image: "https://picsum.photos/id/184/400/240", mileage: "15 KM/L" },
    { id: "12", name: "M8 CNG", engine: "1998 cc", transmission: "Manual", fuel: "Cng", price: "₹98.50 Lakh", image: "https://picsum.photos/id/185/400/240", mileage: "22 KM/Kg" },
  ],
};


import { ExpertOpinionData } from "@/app/utilities/types";

export const BMW_M8_EXPERT_OPINION: ExpertOpinionData = {
  title: "BMW M8 Coupe Competition Expert Opinion",
  subtitle: "In-depth review by our automotive experts",
  sections: [
    {
      id: "overview",
      label: "Overview",
      rating: 4,
      imageUrl: "https://assets.tractorjunction.com/car-junction/images/mahindra-bolero-neo-plus-front-left-side-47-1.webp",
      content:
        "If You Want A Simple Yet Special Commuter, The TVS Radeon Stands Out. We've Ridden Many Commuters, Some Too Basic, Others Too Flashy. The Radeon Is What A Person Needs For Daily Office Commutes, Simple Design, Very Reliable And Fuel Efficient. The BS6 Version Adds Cleaner Emissions And Small Updates Without Losing Personality. If You Want A Simple Yet Special Commuter, The TVS Radeon Stands Out. We've Ridden Many Commuters, Some Too Basic, Others Too Flashy. The Radeon Is What A Person Needs For Daily Office Commutes.",
    },
    {
      id: "exterior",
      label: "Exterior",
      rating: 4.5,
      imageUrl: "https://assets.tractorjunction.com/car-junction/images/mahindra-bolero-neo-plus-front-left-side-47-1.webp",
      content:
        "The BMW M8 Competition Coupe is a visual statement. Long hood, short overhangs, and a wide stance give it a powerful presence. The kidney grille has grown in proportion, flanked by sharp adaptive LED headlights. The M-specific aerodynamics — front splitter, side gills, and rear diffuser — serve both form and function. Available in striking colours like Isle of Man Green Metallic and Frozen Marina Bay Blue.",
    },
    {
      id: "interior",
      label: "Interior",
      rating: 4,
      imageUrl: "https://assets.tractorjunction.com/car-junction/images/mahindra-bolero-neo-plus-front-left-side-47-1.webp",
      content:
        "Inside, the M8 Competition impresses with Merino leather, carbon-fibre trims, and M-specific sport seats that hold you firmly through corners. The 12.3-inch digital instrument cluster and 10.25-inch iDrive infotainment screen are seamlessly integrated. Ambient lighting, a Bowers & Wilkins Diamond surround sound system, and head-up display round out a cabin that feels both luxurious and focused.",
    },
    {
      id: "front-seats",
      label: "Front Seats",
      rating: 4.5,
      content:
        "The M Multifunction front seats are among the best sports seats in the segment. They offer extensive electric adjustment, memory settings, heating, ventilation, and massaging functions. The high bolsters deliver outstanding lateral support during spirited driving, while remaining comfortable over long distances. The driver-focused cockpit layout puts everything within easy reach.",
    },
    {
      id: "rear-seats",
      label: "Rear Seats",
      rating: 3,
      content:
        "The rear seats are a compromise typical of grand tourers. Two adults can sit reasonably comfortably for shorter journeys, but headroom and legroom are noticeably tighter than the front. The fixed transmission tunnel restricts the centre occupant. Ideal for occasional passengers rather than daily rear-seat commuting. Heated rear seats are available as an option.",
    },
    {
      id: "storage",
      label: "Storage and Practicality",
      rating: 3,
      content:
        "Practicality is not the M8's strongest suit but BMW makes a reasonable effort. The centre console houses a deep bin under the armrest, decent door pockets, and a wireless charging pad. The glovebox is average in size. If you need more storage, the Gran Coupe body style offers a noticeably more usable rear cabin and a larger boot.",
    },
    {
      id: "charging",
      label: "Charging Options",
      rating: 3.5,
      content:
        "The M8 Competition is powered by a combustion engine and does not offer plug-in hybrid or electric charging. The 82-litre fuel tank and an average fuel efficiency of around 8–10 km/l in real-world conditions means refuelling stops are frequent during performance driving. BMW's ConnectedDrive app can help locate fuel stations on route.",
    },
    {
      id: "boot",
      label: "Boot Space",
      rating: 3.5,
      content:
        "The M8 Coupe offers a 440-litre boot, which is competitive for the grand tourer segment. The opening is wide enough for large bags and the floor is relatively flat. The rear seats fold in a 50:50 split to extend load capacity when needed. However, the boot lip is high, which makes loading heavy luggage slightly awkward.",
    },
    {
      id: "features",
      label: "Features",
      rating: 4.5,
      content:
        "BMW loads the M8 Competition with technology. Standard kit includes the Live Cockpit Professional, BMW Laserlight headlights, gesture control, parking assistant, night vision assistant, and a 16-speaker Bowers & Wilkins surround sound system. The optional M Driver's Package raises the top speed limiter to 305 km/h. Over-the-air software updates keep the feature set current.",
    },
    {
      id: "safety",
      label: "Safety",
      rating: 4,
      content:
        "The M8 Competition comes with a comprehensive safety suite including front collision warning with city braking, lane departure warning, blind-spot monitoring, rear cross-traffic alert, and a surround-view camera. The M-specific chassis with active M differential, DSC with M Dynamic Mode, and carbon-ceramic brake option deliver exceptional active safety. Euro NCAP has not tested this specific variant independently.",
    },
    {
      id: "variants",
      label: "Variants",
      rating: 4,
      content:
        "The M8 range is available as a Coupe, Convertible, and Gran Coupe. The Competition variant adds an extra 30 hp over the standard M8, reaching 625 hp, along with revised engine mounts and suspension settings. The CS (Club Sport) is the top-of-the-range version with 635 hp, lighter weight, and Michelin Pilot Sport Cup 2 tyres as standard, making it the most track-ready road car in the M8 lineup.",
    },
    {
      id: "engine",
      label: "Engine and Performance",
      rating: 4.5,
      content:
        "At the heart of the M8 Competition sits a twin-turbocharged 4.4-litre V8 producing 625 hp and 750 Nm of torque. Paired with an 8-speed M Steptronic gearbox and M xDrive all-wheel drive, it sprints 0–100 km/h in 3.3 seconds with a top speed electronically limited to 250 km/h (305 km/h with M Driver's Package). The engine note through the active exhaust is spectacular — deeply sonorous at low revs, explosive at high revs.",
    },
    {
      id: "convenience",
      label: "Convenience and Technology",
      rating: 4.5,
      content:
        "The BMW M8 Competition is packed with driver convenience technologies. The BMW Intelligent Personal Assistant responds to voice commands for navigation, media, and climate control. The latest iDrive 7 system is intuitive with fast response times. Remote services via the My BMW App allow remote lock/unlock, vehicle status, and trip planning. The augmented reality head-up display overlays navigation directions on the real road ahead.",
    },
  ],
};

import { ProsConsData } from "@/app/utilities/types";
// ─── BMW M8 Pros Cons ────────────────────────────────────────

export const BMW_M8_Pros_Cons: ProsConsData = {
  title: "How is the BMW M8 Coupe Competition Car",
  sections: [
    {
      type: "pros",
      label: "Pros",
      subLabel: "Reasons to buy",
      points: [
        "It scored five stars in BNCAP crash safety tests and gets six airbags and ISOFIX anchors as standard.",
        "It gets modern features such as a panoramic sunroof, JBL sound system, and wireless charger.",
        "The CNG is offered across all trims without compromising on the 321-litre boot.",
        "The new touch-based AC controls look great, respond well, and include handy toggle switches.",
        "Thanks to its 209mm ground clearance and balanced suspension, it handles potholes confidently.",
      ],
    },
    {
      type: "cons",
      label: "Cons",
      subLabel: "Potential drawbacks",
      points: [
        "The diesel engine can do with more refinement and the throttle response feels delayed up to 2,000 rpm.",
        "The CNG is limited to a manual transmission which may deter city drivers seeking easy shifting.",
        "Fit and finish feels subpar in places and design oddities such as bottle holder and cubby placement.",
        "The touchscreen infotainment display seems to lag or freeze at times.",
        "The CNG is limited to a manual transmission which may deter city drivers seeking easy shifting.",
      ],
    },
  ],
};

export interface ColourOption {
  _id: string;
  name: string;
  hex: string;
  colorImage?: string;

}
 
export interface ColoursData {
  _id: string;
  title: string;
  description: string;
  vehicleImage: string; // URL or local path to the car image
  colours: ColourOption[];
}
 
export const bmwM8ColoursData: ColoursData = {
  _id: "bmw-m8-coupe-colours",
  title: "BMW M8 Coupe Colors",
  description:
    "The M8's cutting-edge safety features include lane keep assist and auto emergency braking for peace of mind.",
  vehicleImage: "https://assets.tractorjunction.com/car-junction/images/models/1768291153113-new_tata_punch.webp",
  colours: [
    {
      _id: "colour-1",
      name: "Brooklyn Grey",
      hex: "#4B5145",
      colorImage: "https://assets.tractorjunction.com/car-junction/images/models/1769575968491-2_RENAULT_Duster.webp",
    },
    {
      _id: "colour-2",
      name: "Mineral White",
      hex: "#E8EEF0",
      colorImage: "https://assets.tractorjunction.com/car-junction/images/models/1771672501579-Hyundai_Staria-_6.webp",
    },
    {
      _id: "colour-3",
      name: "Motegi Red",
      hex: "#8B1A1A",
      colorImage: "https://assets.tractorjunction.com/car-junction/images/models/1771933453000-1_Renault_Kardian.webp",
    },
    {
      _id: "colour-4",
      name: "Imperial Blue",
      hex: "#7AAEC8",
      colorImage: "https://assets.tractorjunction.com/car-junction/images/maruti-eeco-front-left-side-47-1.webp",
    },
    {
      _id: "colour-5",
      name: "Silverstone",
      hex: "#B8BFC6",
      colorImage: "https://assets.tractorjunction.com/car-junction/images/models/1772798913676-02.webpbyd.webp",
    },
    {
      _id: "colour-6",
      name: "Dravit Grey",
      hex: "#4A5568",
      colorImage : "https://assets.tractorjunction.com/car-junction/images/volkswagen-taigun-front-left-side-47-1.webp",
    },
    {
      _id: "colour-7",
      name: "Mineral Grey",
      hex: "#D1D5DB",
      colorImage: "https://assets.tractorjunction.com/car-junction/images/models/1771221676209-Range_Rover_Evoque_1.webp",
    },
    {
      _id: "colour-8",
      name: "Marina Bay Blue",
      hex: "#1A3A4A",
      colorImage: "https://assets.tractorjunction.com/car-junction/images/toyota-rumion-front-left-side-47-1.webp",
    },
    {
      _id: "colour-9",
      name: "Black Sapphire",
      hex: "#1A1A1A",
      colorImage: "https://assets.tractorjunction.com/car-junction/images/renault-kiger-front-left-side-47-1.webp",
    },
  ],
};
 


// Dealer StaticPageData.ts

export const DEALER_SIDEBAR_DATA = [
  {
    id: 1,
    name: "Deutsche Motoren",
    address: "H-8, Sector 63, Noida, Uttar Pradesh",
    distance: "6.2 km away",
    openingTime: "10:00 AM",
    isVerified: true,
  },
  {
    id: 2,
    name: "Bird Automotive",
    address: "Rajouri Garden, New Delhi, Delhi",
    distance: "8.5 km away",
    openingTime: "10:00 AM",
    isVerified: true,
  },
  {
    id: 3,
    name: "Sri Suryambica Automobiles",
    address: "Peddapadu Road, Parvathipuram, Parvathipuram Manyam, Andhra Pradesh",
    distance: "12.4 km away",
    openingTime: "10:00 AM",
    isVerified: true,
  },
];
